const schema = [
  {
    label: "Display name",
    name: "accountName"
  },
  {
    label: "Email",
    name: "contactEmail"
  },
  {
    label: "Phone",
    name: "contactPhone",
    component: "phone-number-input"
  },
  {
    label: "Website",
    name: "contactWeb"
  },
  {
    label: "Enable Request All",
    name: "isRequestAllEnabled",
    component: "switch-input"
  },
  {
    label: "Enable Rebooking",
    name: "isRebookingEnabled",
    component: "switch-input"
  },
  {
    label: "Enable Autoaccept",
    name: "isAutoAcceptEnabled",
    component: "switch-input",
    isSingleLine: true
  },
  {
    label: "Tags",
    name: "tags",
    component: "tags",
    isFieldArray: true
  },
  {
    label: "Notes",
    name: "notes",
    width: "100%",
    component: "multiline-text-input"
  },
  {
    label: "Account owner",
    name: "ownerId",
    component: "dropdown"
  }
];

export default schema.map(field => ({
  ...field,
  placeholder: field.label
}));
